// ability.js
import { AbilityBuilder, createMongoAbility } from '@casl/ability';

export const createAbility = (permissions) => {
    const { can, build } = new AbilityBuilder(createMongoAbility);

    permissions.forEach(permission => {
        const [action, subject] = permission.split('.');
        can(action, subject);
    });

    return build();
};

// Persist ability rules in localStorage
export const ability = createAbility([]);
export const updateAbility = (permissions) => {
    const newAbility = createAbility(permissions);
    ability.update(newAbility.rules);
    localStorage.setItem('abilityRules', JSON.stringify(permissions));
};
